import { render } from "./FavouriteIcon.vue?vue&type=template&id=99e68c3e"
import script from "./FavouriteIcon.vue?vue&type=script&lang=js"
export * from "./FavouriteIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__